import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
export interface FunctionDetailCortexBlockProps {}

const FunctionDetailCortexBlock: React.SFC<FunctionDetailCortexBlockProps> = () => {
  const personDetection = require("../../images/img/person-detection.gif") as string
  const personTracking = require("../../images/img/person-tracking.mp4") as string
  const faceDetection = require("../../images/img/face-detection.jpg") as string
  const attentionDetection = require("../../images/img/attention-detection.jpg") as string
  const emotionDetection = require("../../images/img/emotion-detection.gif") as string
  const maskDetection = require("../../images/img/mask-detection.gif") as string
  const [dataDetail, setDataDetail] = useState([
    {
      idScroll: "persondetection",
      animation: "slide-left",
      title: "Person Detection",
      description: "Detects people and their positions in an image",
      outputs: [
        { output: "Recognition probability", suboutputs: [] },
        { output: "Position", suboutputs: [] },
      ],
      class: "content-right",
      image: personDetection,
      video: "",
    },
    {
      idScroll: "persontracking",
      animation: "slide-right",
      title: "Person Track",
      description: "Detects and tracks the same person in the video",
      outputs: [{ output: "Person ID", suboutputs: [] }],
      class: "content-left",
      image: "",
      video: personTracking,
    },
    {
      idScroll: "facedetection",
      animation: "slide-left",
      title: "Face Detection",
      description: "Detects the face and position of a person in an image",
      outputs: [
        { output: "Recognition probability", suboutputs: [] },
        { output: "Position", suboutputs: [] },
      ],
      class: "content-right",
      image: faceDetection,
      video: "",
    },
    {
      idScroll: "attentiondetection",
      animation: "slide-right",
      title: "Attention Detection",
      description: "Detects a person's line of sight and recognizes whether the person is gazing at it or not",
      outputs: [{ output: "Attention flag (0 or 1)", suboutputs: [] }],
      class: "content-left",
      image: attentionDetection,
      video: "",
    },
    {
      idScroll: "emotionprediction",
      animation: "slide-left",
      title: "Emotion Prediction",
      description: "Estimates and predicts emotions based on detected human facial expressions.",
      outputs: [
        { output: "Recognition probability", suboutputs: [] },
        {
          output: "Emotion type",
          suboutputs: [
            { suboutput: "anger" },
            { suboutput: "disgust" },
            { suboutput: "happy" },
            { suboutput: "neutral" },
            { suboutput: "sad" },
            { suboutput: "surprise" },
          ],
        },
      ],
      class: "content-right",
      image: emotionDetection,
      video: "",
    },
    {
      idScroll: "maskdetection",
      animation: "slide-left",
      title: "Mask Detection",
      description: "Detects whether a mask is worn.",
      outputs: [
        { output: "Recognition probability", suboutputs: [] },
        { output: "Position", suboutputs: [] },
      ],
      class: "content-left height-custom",
      image: maskDetection,
      video: "",
    },
  ])
  return (
    <div className="container-full u-margin-bottom-5">
      <h3 className="u-text-center subtitle-section">Functional Details</h3>
      {dataDetail.map((item, i) => (
        <section
          key={i}
          id={item.idScroll}
          className={`row content-section ${item.class}`}
        >
          <div className="col-lg-6 content-section__description">
            <div className="content-section__description__text">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
              {/* <p>Output:</p> */}
              <table className="content-table">
                <tbody>
                  <tr>
                    <td
                      className="content-table__text"
                      rowSpan={item.outputs.length > 1 ? 3 : 2}
                    >
                      Output
                    </td>
                  </tr>
                  {item.outputs.map((out, j) => (
                    <tr key={j}>
                      <td colSpan={out.suboutputs.length === 0 ? 100 : 1}>
                        {out.output}
                      </td>
                      {out.suboutputs.length === 0 ? (
                        ""
                      ) : (
                        <td>
                          <ul className="list-suboutputs">
                            {out.suboutputs.map((sub, k) => (
                              <li key={k}>{sub.suboutput}</li>
                            ))}
                          </ul>
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <ul>
                {item.outputs.map((out, j) => (
                  <li key={j}>
                    <div>{out.output}</div>
                    <ul>
                      {out.suboutputs.map((sub, k) => (
                        <li key={k}>{sub.suboutput}</li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul> */}
            </div>
          </div>
          <div className="col-lg-6 content-section__image">
            {item.video === "" ? (
              <img src={item.image} alt="" />
            ) : (
              <video controls>
                <source src={item.video} type="video/mp4" />
              </video>
            )}
          </div>
        </section>
      ))}
    </div>
  )
}

export default FunctionDetailCortexBlock
